<p-toast></p-toast>

<div class="fadein animation-duration-200">
    <app-page-data-panel
        title="Delivery Schedule"
        subtitle="Linked execution schedule resolved from target stores, locations, warehousing items, physical reservations or logical coverage, tasks, transport, and deliveries."
        [resultText]="schedules().length + ' of ' + totalScheduleRows() + ' rows'">
        <section class="schedule-header-shell mb-4">
            <div class="schedule-header-main">
                <div class="schedule-header-copy">
                    <span class="schedule-header-copy__eyebrow">Execution Workspace</span>
                    <strong>{{ project().projectName || 'POSM Delivery Schedule' }}</strong>
                    <p>Plan, allocate, release, and track execution rows from one delivery schedule workspace.</p>
                </div>

            </div>

            <div class="schedule-header-metrics">
                <div class="schedule-metric-card schedule-metric-card--primary">
                    <span>Visible rows</span>
                    <strong>{{ schedules().length }}</strong>
                    <small>{{ totalScheduleRows() }} total linked rows</small>
                </div>
                <div class="schedule-metric-card">
                    <span>Due now</span>
                    <strong>{{ dueNowCount() }}</strong>
                    <small>Rows marked due today or overdue</small>
                </div>
                <div class="schedule-metric-card">
                    <span>Unresolved</span>
                    <strong>{{ unresolvedCount() }}</strong>
                    <small>Rows still carrying mapping issues</small>
                </div>
                <div class="schedule-metric-card">
                    <span>Selected</span>
                    <strong>{{ selectedCount() }}</strong>
                    <small>{{ selectedInstallationEligibleCount() }} installation-ready in selection</small>
                </div>
            </div>

            <div class="schedule-context schedule-context--hero">
                <div>
                    <span>Project</span>
                    <strong>{{ project().projectNumber || '-' }}</strong>
                </div>
                <div>
                    <span>Client</span>
                    <strong>{{ projectClientLabel() }}</strong>
                </div>
                <div>
                    <span>Execution Type</span>
                    <strong>{{ project().jobType || project().jobTypeGroup || 'POSM rollout' }}</strong>
                </div>
                <div>
                    <span>Job Name</span>
                    <strong>{{ project().projectName || '-' }}</strong>
                </div>
            </div>

        </section>

        @if (actionFeedback(); as feedback) {
            <section
                class="action-feedback mb-4"
                [class.action-feedback--success]="feedback.tone === 'success'"
                [class.action-feedback--warn]="feedback.tone === 'warn'"
                [class.action-feedback--danger]="feedback.tone === 'danger'"
                [class.action-feedback--info]="feedback.tone === 'info'"
                aria-live="polite">
                <div class="action-feedback__header">
                    <div class="action-feedback__identity">
                        <span class="action-feedback__icon">
                            <i [class]="actionFeedbackIcon(feedback.tone)"></i>
                        </span>
                        <div>
                            <span class="action-feedback__eyebrow">
                                {{ feedback.action === 'allocation' ? 'Material allocation' : 'Installation releases' }}
                            </span>
                            <strong>{{ feedback.title }}</strong>
                        </div>
                    </div>
                    <button
                        type="button"
                        class="action-feedback__dismiss"
                        aria-label="Dismiss action results"
                        (click)="clearActionFeedback()">
                        <i class="pi pi-times"></i>
                    </button>
                </div>

                <p class="action-feedback__summary">{{ feedback.summary }}</p>

                @if (feedback.items.length) {
                    <div class="action-feedback__list">
                        @for (item of feedback.items; track item.scheduleLabel + '-' + $index) {
                            <article class="action-feedback__item">
                                <div class="action-feedback__item-head">
                                    <strong>{{ item.scheduleLabel }}</strong>
                                    @if (item.status) {
                                        <span>{{ item.status }}</span>
                                    }
                                </div>
                                <ul>
                                    @for (message of item.messages; track message) {
                                        <li>{{ message }}</li>
                                    }
                                </ul>
                            </article>
                        }
                    </div>
                }
            </section>
        }

        @if (activeFilterSummary().length || filtersExpanded()) {
        <div class="filter-shell mb-4">
            @if (activeFilterSummary().length) {
                <div class="filter-shell__summary">
                    <span class="filter-shell__summary-label">Active filters</span>
                    <div class="filter-shell__summary-chips">
                        @for (filter of activeFilterSummary(); track filter.key) {
                            <button type="button" class="filter-chip" (click)="clearSingleFilter(filter.key)">
                                <span>{{ filter.label }}: {{ filter.value }}</span>
                                <i class="pi pi-times"></i>
                            </button>
                        }
                    </div>
                </div>
            }
            @if (filtersExpanded()) {
                <div class="grid mt-2">
                    <div class="col-12 md:col-3">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                            <p-iftalabel>
                                <p-multiSelect [options]="retailerOptions()" optionLabel="label" optionValue="value" [ngModel]="filters().retailer" (ngModelChange)="updateFilter('retailer', $event)" [ngModelOptions]="{ standalone: true }" [showClear]="true" [filter]="true" [loading]="isFilterOptionsLoading('retailer')" [emptyMessage]="filterEmptyMessage('retailer')" [emptyFilterMessage]="filterEmptyMessage('retailer')" [showToggleAll]="false" selectedItemsLabel="{0} retailers selected" (onPanelShow)="loadFilterOptions('retailer')" (onFilter)="loadFilterOptions('retailer', $event.filter)" appendTo="body" styleClass="w-full"></p-multiSelect>
                                <label>Retailer / Store Chain</label>
                            </p-iftalabel>
                        </p-inputGroup>
                    </div>
                    <div class="col-12 md:col-3">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
                            <p-iftalabel>
                                <p-multiSelect [options]="storeOptions()" optionLabel="label" optionValue="value" [ngModel]="filters().store" (ngModelChange)="updateFilter('store', $event)" [ngModelOptions]="{ standalone: true }" [showClear]="true" [filter]="true" [loading]="isFilterOptionsLoading('store')" [emptyMessage]="filterEmptyMessage('store')" [emptyFilterMessage]="filterEmptyMessage('store')" [showToggleAll]="false" selectedItemsLabel="{0} stores selected" (onPanelShow)="loadFilterOptions('store')" (onFilter)="loadFilterOptions('store', $event.filter)" appendTo="body" styleClass="w-full"></p-multiSelect>
                                <label>Store / Location</label>
                            </p-iftalabel>
                        </p-inputGroup>
                    </div>
                    <div class="col-12 md:col-3">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-building-columns"></i></p-inputGroupAddon>
                            <p-iftalabel>
                                <p-multiSelect [options]="cityOptions()" optionLabel="label" optionValue="value" [ngModel]="filters().city" (ngModelChange)="updateFilter('city', $event)" [ngModelOptions]="{ standalone: true }" [showClear]="true" [filter]="true" [loading]="isFilterOptionsLoading('city')" [emptyMessage]="filterEmptyMessage('city')" [emptyFilterMessage]="filterEmptyMessage('city')" [showToggleAll]="false" selectedItemsLabel="{0} cities selected" (onPanelShow)="loadFilterOptions('city')" (onFilter)="loadFilterOptions('city', $event.filter)" appendTo="body" styleClass="w-full"></p-multiSelect>
                                <label>City</label>
                            </p-iftalabel>
                        </p-inputGroup>
                    </div>
                    <div class="col-12 md:col-3">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-box"></i></p-inputGroupAddon>
                            <p-iftalabel>
                                <p-multiSelect [options]="itemOptions()" optionLabel="label" optionValue="value" [ngModel]="filters().item" (ngModelChange)="updateFilter('item', $event)" [ngModelOptions]="{ standalone: true }" [showClear]="true" [filter]="true" [loading]="isFilterOptionsLoading('item')" [emptyMessage]="filterEmptyMessage('item')" [emptyFilterMessage]="filterEmptyMessage('item')" [showToggleAll]="false" selectedItemsLabel="{0} items selected" (onPanelShow)="loadFilterOptions('item')" (onFilter)="loadFilterOptions('item', $event.filter)" appendTo="body" styleClass="w-full"></p-multiSelect>
                                <label>Stand / Warehousing Item</label>
                            </p-iftalabel>
                        </p-inputGroup>
                    </div>
                    <div class="col-12 md:col-3">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                            <p-iftalabel>
                                <p-select [options]="supplierOptions()" optionLabel="label" optionValue="value" [ngModel]="filters().supplier" (ngModelChange)="updateFilter('supplier', $event)" [ngModelOptions]="{ standalone: true }" [showClear]="true" [filter]="true" [loading]="isFilterOptionsLoading('supplier')" [emptyMessage]="filterEmptyMessage('supplier')" [emptyFilterMessage]="filterEmptyMessage('supplier')" (onShow)="loadFilterOptions('supplier')" (onFilter)="loadFilterOptions('supplier', $event.filter)" appendTo="body" styleClass="w-full"></p-select>
                                <label>Supplier</label>
                            </p-iftalabel>
                        </p-inputGroup>
                    </div>
                    <div class="col-12 md:col-3">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-shield"></i></p-inputGroupAddon>
                            <p-iftalabel>
                                <p-select [options]="readinessOptions()" optionLabel="label" optionValue="value" [ngModel]="filters().readiness" (ngModelChange)="updateFilter('readiness', $event)" [ngModelOptions]="{ standalone: true }" [showClear]="true" [filter]="true" [loading]="isFilterOptionsLoading('readiness')" [emptyMessage]="filterEmptyMessage('readiness')" [emptyFilterMessage]="filterEmptyMessage('readiness')" (onShow)="loadFilterOptions('readiness')" (onFilter)="loadFilterOptions('readiness', $event.filter)" appendTo="body" styleClass="w-full"></p-select>
                                <label>Readiness</label>
                            </p-iftalabel>
                        </p-inputGroup>
                    </div>
                    <div class="col-12 md:col-3">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-clock"></i></p-inputGroupAddon>
                            <p-iftalabel>
                                <p-select [options]="dueStatusOptions()" optionLabel="label" optionValue="value" [ngModel]="filters().dueStatus" (ngModelChange)="updateFilter('dueStatus', $event)" [ngModelOptions]="{ standalone: true }" [showClear]="true" [filter]="true" [loading]="isFilterOptionsLoading('dueStatus')" [emptyMessage]="filterEmptyMessage('dueStatus')" [emptyFilterMessage]="filterEmptyMessage('dueStatus')" (onShow)="loadFilterOptions('dueStatus')" (onFilter)="loadFilterOptions('dueStatus', $event.filter)" appendTo="body" styleClass="w-full"></p-select>
                                <label>Due Status</label>
                            </p-iftalabel>
                        </p-inputGroup>
                    </div>
                    <div class="col-12 md:col-3">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-chart-line"></i></p-inputGroupAddon>
                            <p-iftalabel>
                                <p-select [options]="progressStageOptions()" optionLabel="label" optionValue="value" [ngModel]="filters().progressStage" (ngModelChange)="updateFilter('progressStage', $event)" [ngModelOptions]="{ standalone: true }" [showClear]="true" [filter]="true" [loading]="isFilterOptionsLoading('progressStage')" [emptyMessage]="filterEmptyMessage('progressStage')" [emptyFilterMessage]="filterEmptyMessage('progressStage')" (onShow)="loadFilterOptions('progressStage')" (onFilter)="loadFilterOptions('progressStage', $event.filter)" appendTo="body" styleClass="w-full"></p-select>
                                <label>Schedule Progress</label>
                            </p-iftalabel>
                        </p-inputGroup>
                    </div>
                    <div class="col-12 md:col-3">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-send"></i></p-inputGroupAddon>
                            <p-iftalabel>
                                <p-select [options]="releaseStatusOptions()" optionLabel="label" optionValue="value" [ngModel]="filters().releaseStatus" (ngModelChange)="updateFilter('releaseStatus', $event)" [ngModelOptions]="{ standalone: true }" [showClear]="true" [filter]="true" [loading]="isFilterOptionsLoading('releaseStatus')" [emptyMessage]="filterEmptyMessage('releaseStatus')" [emptyFilterMessage]="filterEmptyMessage('releaseStatus')" (onShow)="loadFilterOptions('releaseStatus')" (onFilter)="loadFilterOptions('releaseStatus', $event.filter)" appendTo="body" styleClass="w-full"></p-select>
                                <label>Release Status</label>
                            </p-iftalabel>
                        </p-inputGroup>
                    </div>
                    <div class="col-12 md:col-3">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon>
                            <p-iftalabel>
                                <p-select [options]="truckOptions()" optionLabel="label" optionValue="value" [ngModel]="filters().truck" (ngModelChange)="updateFilter('truck', $event)" [ngModelOptions]="{ standalone: true }" [showClear]="true" [filter]="true" [loading]="isFilterOptionsLoading('truck')" [emptyMessage]="filterEmptyMessage('truck')" [emptyFilterMessage]="filterEmptyMessage('truck')" (onShow)="loadFilterOptions('truck')" (onFilter)="loadFilterOptions('truck', $event.filter)" appendTo="body" styleClass="w-full"></p-select>
                                <label>Truck</label>
                            </p-iftalabel>
                        </p-inputGroup>
                    </div>
                    <div class="col-12 md:col-3">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
                            <p-iftalabel>
                                <p-select [options]="driverOptions()" optionLabel="label" optionValue="value" [ngModel]="filters().driver" (ngModelChange)="updateFilter('driver', $event)" [ngModelOptions]="{ standalone: true }" [showClear]="true" [filter]="true" [loading]="isFilterOptionsLoading('driver')" [emptyMessage]="filterEmptyMessage('driver')" [emptyFilterMessage]="filterEmptyMessage('driver')" (onShow)="loadFilterOptions('driver')" (onFilter)="loadFilterOptions('driver', $event.filter)" appendTo="body" styleClass="w-full"></p-select>
                                <label>Driver</label>
                            </p-iftalabel>
                        </p-inputGroup>
                    </div>
                    <div class="col-12 md:col-3">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-chart-line"></i></p-inputGroupAddon>
                            <p-iftalabel>
                                <p-select [options]="shipmentStatusOptions()" optionLabel="label" optionValue="value" [ngModel]="filters().shipmentStatus" (ngModelChange)="updateFilter('shipmentStatus', $event)" [ngModelOptions]="{ standalone: true }" [showClear]="true" [filter]="true" [loading]="isFilterOptionsLoading('shipmentStatus')" [emptyMessage]="filterEmptyMessage('shipmentStatus')" [emptyFilterMessage]="filterEmptyMessage('shipmentStatus')" (onShow)="loadFilterOptions('shipmentStatus')" (onFilter)="loadFilterOptions('shipmentStatus', $event.filter)" appendTo="body" styleClass="w-full"></p-select>
                                <label>Shipment Status</label>
                            </p-iftalabel>
                        </p-inputGroup>
                    </div>
                </div>

            }
        </div>
        }

        <div class="schedule-card-toolbar">
            <label class="select-visible">
                <p-checkbox
                    [binary]="true"
                    [ngModel]="allVisibleEligibleSelected()"
                    (ngModelChange)="toggleVisibleSelection($event)"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="!visibleSchedules().length"></p-checkbox>
                <span>Select visible schedules</span>
            </label>
            <span class="muted-line">
                {{ selectedVisibleCount() }} selected in view |
                {{ visibleInstallationEligibleSchedules().length }} installation-ready
                @if (supportsRemovalFlow()) {
                    <span> | {{ visibleRemovalEligibleSchedules().length }} removal-ready</span>
                }
            </span>
        </div>

        @if (totalScheduleRows() > schedules().length || currentPage() > 0 || hasMoreSchedules()) {
            <div class="schedule-pagination schedule-pagination--top">
                <p-paginator
                    [rows]="pageSize()"
                    [first]="currentPage() * pageSize()"
                    [totalRecords]="totalScheduleRows()"
                    [rowsPerPageOptions]="[12, 25, 50]"
                    [showFirstLastIcon]="true"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first}-{last} of {totalRecords} rows"
                    (onPageChange)="onPageChange($event)"></p-paginator>
            </div>
        }

        @if (loading()) {
            <div class="empty-card">Loading delivery schedules.</div>
        } @else if (!schedules().length && !totalScheduleRows()) {
            <div class="empty-card">No linked delivery schedule rows found. Add target stores and project items, then refresh this tab.</div>
        } @else if (!filteredSchedules().length) {
            <div class="empty-card">No delivery schedule rows match the current filters on this page.</div>
        } @else {
            <div class="schedule-ledger-list">
                @for (row of filteredSchedules(); track row.id || row.sourceRowHash) {
                    <article
                        class="schedule-ledger-row"
                        [class.selected]="isRowSelected(row)"
                        [class.tone-danger]="scheduleTone(row) === 'danger'"
                        [class.tone-warn]="scheduleTone(row) === 'warn'"
                        [class.tone-active]="scheduleTone(row) === 'active'"
                        [class.tone-success]="scheduleTone(row) === 'success'"
                        [class.tone-info]="scheduleTone(row) === 'info'">
                        <div class="schedule-ledger-head">
                            <label class="schedule-select">
                                <p-checkbox
                                    [binary]="true"
                                    [ngModel]="isRowSelected(row)"
                                    (ngModelChange)="toggleRowSelection(row, $event)"
                                    [ngModelOptions]="{ standalone: true }"></p-checkbox>
                            </label>

                            <div class="schedule-ledger-title">
                                <span>Delivery Schedule</span>
                                <strong>{{ row.scheduleNumber || ('Schedule #' + row.id) }}</strong>
                                <small>{{ scheduleDatesLabel(row) }}</small>
                            </div>

                            <div class="schedule-ledger-progress">
                                <div class="schedule-ledger-progress__meta">
                                    <span>{{ progressLabel(row) }}</span>
                                    <strong>{{ progressWidth(row) }}</strong>
                                </div>
                                <div class="schedule-progress">
                                    <span [style.width]="progressWidth(row)"></span>
                                </div>
                            </div>

                            <div class="schedule-ledger-actions">
                                <p-button icon="pi pi-arrow-right" label="Open Details" [disabled]="!row.id" (click)="openScheduleDetail(row)"></p-button>
                            </div>
                        </div>

                        <div class="schedule-ledger-state">
                            <div class="schedule-ledger-tags">
                                <p-tag [value]="installationStatusLabel(row)" [severity]="readinessSeverity(row.readinessStatus)"></p-tag>
                                @if (supportsRemovalFlow() && row.removalReadinessStatus) {
                                    <p-tag [value]="removalStatusLabel(row)" [severity]="readinessSeverity(row.removalReadinessStatus)"></p-tag>
                                }
                                @if (row.allocationActionRequired !== false) {
                                    <p-tag [value]="allocationLabel(row)" [severity]="row.allocationStatus === 'ALLOCATED' ? 'success' : (row.allocationStatus === 'PARTIAL' ? 'warning' : 'danger')"></p-tag>
                                }
                                <p-tag [value]="coverageModeLabel(row)" [severity]="coverageModeSeverity(row)"></p-tag>
                                <p-tag [value]="progressLabel(row)" [severity]="progressSeverity(row.progressStage || row.status)"></p-tag>
                                @if (supportsRemovalFlow() && row.returnOutcomeStatus) {
                                    <p-tag [value]="returnOutcomeLabel(row)" [severity]="statusSeverity(row.returnOutcomeStatus)"></p-tag>
                                }
                            </div>
                        </div>

                        <div class="schedule-ledger-band">
                            <button class="entity-card entity-card--location" type="button" (click)="openLocation(row)" [disabled]="!row.location?.id">
                                <i class="pi pi-map-marker"></i>
                                <div>
                                    <div class="entity-card__identity">
                                        <span>Retailer / Store Chain</span>
                                        <strong>{{ retailerLabel(row) }}</strong>
                                        <small>{{ retailerSourceLabel(row) }}</small>
                                    </div>
                                    <div class="entity-card__identity">
                                        <span>Store Location</span>
                                        <strong>{{ locationLabel(row) }}</strong>
                                        <small>{{ locationReference(row) }} | {{ row.city || 'City pending' }}</small>
                                    </div>
                                </div>
                            </button>

                            <button class="entity-card entity-card--item" type="button" (click)="openItem(row)" [disabled]="!row.inventoryItem?.id">
                                <i class="pi pi-box"></i>
                                <div>
                                    <span>Stand / Item</span>
                                    <strong>{{ itemLabel(row) }}</strong>
                                    <small>Item {{ itemNumber(row) }} | SKU {{ itemSku(row) }} | Size {{ itemSize(row) }} | Qty {{ row.standQty || row.projectItem?.quantity || 0 }}</small>
                                </div>
                            </button>

                            @if (row.supplierClientId) {
                                <button class="entity-card entity-card--supply" type="button" (click)="openSupplier(row)">
                                    <i class="pi pi-building"></i>
                                    <div>
                                        <span>Supply Source</span>
                                        <strong>{{ supplySourceLabel(row) }}</strong>
                                        <small>{{ supplySourceDetail(row) }}</small>
                                    </div>
                                </button>
                            } @else {
                                <div class="entity-card entity-card--supply entity-card--static">
                                    <i class="pi pi-building"></i>
                                    <div>
                                        <span>Supply Source</span>
                                        <strong>{{ supplySourceLabel(row) }}</strong>
                                        <small>{{ supplySourceDetail(row) }}</small>
                                    </div>
                                </div>
                            }
                        </div>

                        <div class="schedule-ledger-grid" [class.with-removal]="supportsRemovalFlow()">
                            <div>
                                <span>Allocation</span>
                                <strong>{{ row.allocatedQuantity || 0 }} / {{ row.requiredQuantity || row.standQty || row.projectItem?.quantity || 0 }}</strong>
                                @if (row.allocationActionRequired !== false) {
                                    <small>{{ allocationLabel(row) }}</small>
                                }
                            </div>
                            <div>
                                <span>Due</span>
                                <strong>{{ dueLabel(row) }}</strong>
                                <small>Install {{ formattedDate(installationCommitmentDate(row)) }}</small>
                            </div>
                            <div>
                                <span>Release</span>
                                <strong>{{ row.releaseNumber || (row.transportReleaseId ? ('Release #' + row.transportReleaseId) : 'No release') }}</strong>
                                <small>{{ row.deliveryNumber || row.shipmentStatus || row.transportStatus || 'Execution not linked yet' }}</small>
                            </div>
                            @if ((row.transportReleaseGroups || []).length > 1) {
                                <div>
                                    <span>Release Groups</span>
                                    @for (group of row.transportReleaseGroups || []; track group.sourceWarehouseId) {
                                        <strong>{{ group.sourceWarehouseName || ('Warehouse #' + (group.sourceWarehouseId || '-')) }} · {{ group.allocatedQuantity || 0 }}</strong>
                                        <small>{{ group.releaseNumber || 'Release pending' }} · {{ group.releaseStatus || group.validationStatus || 'Pending' }}</small>
                                    }
                                </div>
                            }
                            <div>
                                <span>Truck / Driver</span>
                                <strong>{{ row.truckName || '-' }}</strong>
                                <small>{{ row.driverName || 'Driver pending' }}</small>
                            </div>
                            <div>
                                <span>Contact</span>
                                <strong>{{ row.contactNumberOverride || row.contactNumber || '-' }}</strong>
                                <small>{{ row.storeNumber || locationReference(row) }}</small>
                            </div>
                            <div>
                                <span>Movement / Source</span>
                                <strong>{{ sourceCoverageLabel(row) }}</strong>
                                <small>{{ coverageModeLabel(row) }}</small>
                            </div>
                            @if (supportsRemovalFlow()) {
                                <div>
                                    <span>Removal Release</span>
                                    <strong>{{ row.removalReleaseNumber || (row.removalTransportReleaseId ? ('Release #' + row.removalTransportReleaseId) : 'No removal release') }}</strong>
                                    <small>Remove {{ formattedDate(removalCommitmentDate(row)) }}</small>
                                </div>
                                <div>
                                    <span>Return Outcome</span>
                                    <strong>{{ returnOutcomeLabel(row) }}</strong>
                                    <small>{{ row.returnDestinationType || 'Return routing pending' }}</small>
                                </div>
                            }
                        </div>

                        @if (hasScheduleIssueContent(row)) {
                            <div class="schedule-ledger-foot">
                                @if (scheduleIssueGroups(row).length) {
                                    <div
                                        class="issue-summary"
                                        [class.issue-summary--active]="isShipmentExecutionActive(row) && !scheduleHasBlockingIssues(row)">
                                        <div class="issue-summary__icon">
                                            <i [class]="isShipmentExecutionActive(row) && !scheduleHasBlockingIssues(row) ? 'pi pi-truck' : 'pi pi-exclamation-triangle'"></i>
                                        </div>
                                        <div class="issue-summary__body">
                                            <span>{{ scheduleIssueSummaryLabel(row) }}</span>
                                            <strong>{{ scheduleIssueSummaryText(row) }}</strong>
                                        </div>
                                    </div>

                                    <div class="issue-groups">
                                        @for (group of scheduleIssueGroups(row); track group.key) {
                                            <section
                                                class="issue-group"
                                                [class.issue-group--danger]="group.tone === 'danger'"
                                                [class.issue-group--warn]="group.tone === 'warn'"
                                                [class.issue-group--active]="group.tone === 'active'"
                                                [class.issue-group--info]="group.tone === 'info'">
                                                <div class="issue-group__head">
                                                    <div class="issue-group__title">
                                                        <i [class]="group.icon"></i>
                                                        <div>
                                                            <strong>{{ group.label }}</strong>
                                                            <small>{{ group.hint }}</small>
                                                        </div>
                                                    </div>
                                                    <span class="issue-group__count">{{ group.items.length }}</span>
                                                </div>
                                                <div class="issue-group__items">
                                                    @for (item of group.items; track item) {
                                                        <div class="issue-item">
                                                            <i class="pi pi-circle-fill"></i>
                                                            <span>{{ item }}</span>
                                                        </div>
                                                    }
                                                </div>
                                            </section>
                                        }
                                    </div>
                                }
                                @if (row.nextAction) {
                                    <div class="next-action-strip">
                                        <div>
                                            <span>Next action</span>
                                            <strong>{{ row.nextAction }}</strong>
                                        </div>
                                        <i class="pi pi-arrow-right"></i>
                                    </div>
                                }
                            </div>
                        }
                    </article>
                }
            </div>
        }
        @if (totalScheduleRows() > schedules().length || currentPage() > 0 || hasMoreSchedules()) {
            <div class="schedule-pagination schedule-pagination--bottom">
                <p-paginator
                    [rows]="pageSize()"
                    [first]="currentPage() * pageSize()"
                    [totalRecords]="totalScheduleRows()"
                    [rowsPerPageOptions]="[12, 25, 50]"
                    [showFirstLastIcon]="true"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first}-{last} of {totalRecords} rows"
                    (onPageChange)="onPageChange($event)"></p-paginator>
            </div>
        }
    </app-page-data-panel>

    <p-dialog
        [header]="viewerDialogHeader()"
        [modal]="true"
        [visible]="showViewerDialog()"
        (visibleChange)="$event ? showViewerDialog.set(true) : closeViewerDialog()"
        [style]="{ width: '96vw', maxWidth: '1500px' }"
        [contentStyle]="{ padding: '0', overflow: 'hidden' }"
        appendTo="body">
        @if (viewerDialogUrl()) {
            <iframe
                class="embedded-view-frame"
                [src]="viewerDialogUrl()"
                [title]="viewerDialogHeader()"></iframe>
        }
    </p-dialog>

</div>
